<template>
  <div id="indexDealers">
    <!--头部-->
    <el-row style="margin-top: -21px;">
      <el-col :span="24">
        <el-card class="box-card">
          <div style="width: 100%;text-align: right;line-height: 40px;height: 40px;">
            <div style="font-size: 16px;font-weight: bold;float: left;">
              {{realname}}
            </div>
            <div style="font-size: 24px;font-weight: bold;float: right;">
              {{score}}
            </div>
            <div style="float: right;padding: 0 5px 0 10px;">
              <el-tooltip class="item" effect="dark" :content="'积分周期：'+ this.cycleList" placement="top">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </div>
            <div style="float: right;color: #00000072;">
              信用积分
            </div>
          </div>
          <el-row>
            <el-col :span="8">
              <div style="float: left;color: #00000072;width: 50%;">
                档案完成度：{{integrity}}
              </div>
              <div style="float: left;color: #409EFF;cursor: pointer;" @click="jumpType()">
                完善/修改信息
              </div>
            </el-col>
            <el-col :span="8">
              <div style="float: left;color: #00000072;width: 50%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                微信绑定：{{nickname}}
              </div>
              <div style="float: left;color: #409EFF;cursor: pointer;" @click="onWechat(openid)">
                绑定微信
              </div>
            </el-col>
            <el-col :span="8">
              <div style="float: right;color: #409EFF;cursor: pointer;" @click="$router.push('/CreditScoreShow')">
                积分规则
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12" style="margin-bottom: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          快捷入口
        </div>
      </el-col>
      <el-col :span="12" style="margin-bottom: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          待办事项
        </div>
      </el-col>
      <el-col :span="12">
        <el-card style="margin: 0 20px 20px 0;">
          <el-row>
            <div class="approvalHover">
              <el-col :span="12" class="ellipsisStyle" style="background-color: #FAFAFA;height: 61px;line-height: 61px;margin-right: 10px;width: calc(50% - 10px);text-align: center;">
                <span class="titleSpan" @click="$router.push('/ActivityDeclaration/:id')">活动申报入口</span>
              </el-col>
              <el-col :span="12" class="ellipsisStyle"  style="background-color: #FAFAFA;height: 61px;line-height: 61px;margin-left: 10px;width: calc(50% - 10px);text-align: center;">
                <span class="titleSpan" @click="$router.push('/CreditScoreOutInform')">违规信息举报入口</span>
              </el-col>
            </div>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card style="margin: 0 0 20px 0;">
          <el-row>
            <div class="approvalHover">
              <el-col :span="9" class="ellipsisStyle">
                <div style="width: 195px;">
                  <el-image class="approvalHoverImage" :src="require('@/assets/img/other/dealers_header3.png')"></el-image>
                  <span class="titleSpan" @click="$router.push('/record')">违规举报待我响应</span>
                </div>
              </el-col>
              <el-col :span="3">
                <span class="titleSpan2">{{illegalCount?illegalCount:0}}</span>
              </el-col>
              <!-- <el-col :span="9">
                <div style="width: 201px;white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;">
                  <el-image class="approvalHoverImage" :src="require('@/assets/img/other/dealers_header4.png')"></el-image>
                  <span class="titleSpan" @click="$router.push('/record')">违规信息可二次申诉</span>
                </div>
              </el-col>
              <el-col :span="3">
                <span class="titleSpan2">{{illegalCount2?illegalCount2:0}}</span>
              </el-col> -->
            </div>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-col :span="24" style="margin-bottom: 20px;">
      <div style="font-size: 16px;color: #333333;display: flex;">
        <div class="iconDiv">
          .
        </div>
        活动审批进程
      </div>
    </el-col>
    <el-col :span="24">
      <el-card v-loading="findCampaignsLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="height: 192px;"
      >
        <div class="bscroll" ref="bscroll" id="el-cardShadow">
          <div class="bscroll-container">
            <div style="display: flex;">
              <el-card style="cursor: pointer;width: 500px;margin-right: 20px;background-color: #FAFAFA;"  v-for="item in findData">
                <div @click="$router.push('/ActivityDeclaration/' + item.id)">
                  <el-row style="padding: 20px;">
                    <el-col :span="20" style="text-align: left;font-weight: bold;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
                      {{item.campaign_name}}
                    </el-col>
                    <el-col :span="4" style="text-align: right;">
                      <span style="color: #999999;">
                        <span v-if="item.campaign_node == '审批中'">
                          ●
                        </span>
                        <span style="color: rgb(64, 158, 255);" v-else>
                          ●
                        </span>
                        {{item.campaign_node}}
                      </span>
                    </el-col>
                    <el-col :span="24" style="text-align: left;margin-top: 8px;color: #000000A5;">
                      {{item.activity_number}}
                    </el-col>
                    <el-col :span="24" style="text-align: left;margin-top: 8px;color: #000000A5;">
                      活动时间：{{item.start_time | fullTime}}  ~  {{item.end_time | fullTime}}
                    </el-col>
                    <el-col :span="24" style="text-align: left;margin-top: 8px;">
                      <span style="margin-right: 20px;">{{item.dict_code | platformChinese}}</span>
                      <span style="margin-right: 30px;">{{item.shop_name}}</span>
                      <span style="color: #999999;">{{item.createtime | fullTime}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-card>

            </div>
          </div>
        </div>
      </el-card>
      <div
        v-if="findData.length == 0"
        style="position: absolute;
        top: 402px;
        left: 30px;
        height: 191px;
        width: calc(100% - 80px);
        text-align: center;
        background-color: white;">
        <img src="../../../assets/img/other/nodata.svg" style="margin-top: 83px;">
        <div>
          暂无数据
        </div>
      </div>
    </el-col>
    <el-col :span="12" style="margin: 20px 0 20px 0;">
      <div style="font-size: 16px;color: #333333;display: flex;">
        <div class="iconDiv">
          .
        </div>
        通知公告
      </div>
    </el-col>
    <el-col :span="12" style="margin: 20px 0 20px 0;">
      <div style="font-size: 16px;color: #333333;display: flex;">
        <div class="iconDiv">
          .
        </div>
        今日活动公示
      </div>
    </el-col>
    <el-col :span="12">
      <div class="noData" v-if="tableData.length == 0">
        <img src="../../../assets/img/other/nodata.svg" style="margin-top: 83px;">
        <div>
          暂无数据
        </div>
      </div>
      <el-card v-if="tableData.length != 0"
        style="height: 555px;margin-right: 20px;overflow-y: auto;margin-bottom: 20px;"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading">
        <div class="contentStyle" v-for="item in tableData" @click="DetailsPage(item.id)">
          <div style="font-weight: bold;white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;">
            {{item.notice_title}}
          </div>
          <div class="ellipsisStyle2">
            {{ToText(item.notice_content)}}
          </div>
          <div style="width: 100%;margin-top: 8px;">
            <el-col :span="12">
              <div style="text-align: left;color: #999999;">
                {{item.notice_typename}}
              </div>
            </el-col>
            <el-col :span="12">
              <div style="text-align: right;color: #999999;">
                {{item.createtime | fullTime}}
              </div>
            </el-col>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col :span="12">
      <el-card style="height: 555px;margin-bottom: 20px;" v-loading="scheduleDataLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading">
        <div style="height: 32px;margin-bottom: 20px;">
          <div style="float: left;">
            <el-radio-group v-model="productType" size="small" @change="ScheduleBMC">
              <el-radio-button label="活动店铺"></el-radio-button>
              <el-radio-button label="活动产品"></el-radio-button>
            </el-radio-group>
          </div>
          <div style="float: right;color: #999999;">
            <span v-if="productType == '活动店铺'">
              活动店铺数
            </span>
            <span v-else>
              活动产品数
            </span>
            <span style="font-size: 24px;padding-left: 20px;">
              {{productNum}}
            </span>
          </div>
        </div>
        <div class="noData" v-if="scheduleData.length == 0">
          <img src="../../../assets/img/other/nodata.svg" style="margin-top: 83px;">
          <div>
            暂无数据
          </div>
        </div>
        <div style="overflow-y: auto;height: 723px;" v-if="scheduleData.length != 0">
          <div style="width: 100%;height: 64px;margin-top: 8px;border-bottom: 1px solid #e8ebec;" v-if="productType == '活动店铺'" v-for="item in scheduleData" @click="$router.push('/ActivityPublicity')">
            <el-col :span="12">
              <div style="text-align: left;font-weight: bold;">
                {{item.campaign_name}}
              </div>
            </el-col>
            <el-col :span="12">
              <div style="text-align: right;color: #999999;">
                {{item.activity_number}}
              </div>
            </el-col>
            <el-col :span="12">
              <div style="text-align: left;margin-top: 8px;color: #999999;">
                <span style="padding-right: 40px;">
                  {{item.platform_code | platformChinese}}
                </span>
                <span>
                  {{item.shop_name}}
                </span>
              </div>
            </el-col>
          </div>

          <div style="width: 100%;height: 64px;margin-top: 8px;border-bottom: 1px solid #e8ebec;" v-if="productType != '活动店铺'"  v-for="item2 in scheduleData">
            <el-col :span="24">
              <div style="font-weight: bold;">
                {{item2.product_info}}
              </div>
            </el-col>
            <el-col :span="12">
              <div style="text-align: left;margin-top: 8px;color: #999999;">
                <span>
                  活动店铺数：{{item2.count}}
                </span>
              </div>
            </el-col>
          </div>
        </div>

      </el-card>
    </el-col>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import filter from "../../../libs/filterall";
import { mapActions } from "vuex";
import {fetchGet, fetchPost} from "@/libs/reqCommon";
import wxBindingComponent from "../../../components/wxComponent/wxBindingComponent.vue";

export default {
  components:{wxBindingComponent},
  data: function() {
    return {
      scheduleData: [],
      productType: '活动店铺',
      activeList: [],
      activeIndex: 0,
      count: 0,
      //热门活动产品
      dateActive: {
        pageNum: 5,
        pageSize: 1
      },
      hotActivity: [],
      //活动店铺
      shopActive: {
        pageNum: 100,
        pageSize: 1
      },
      shopActivityList: [],
      headerNum: {},
      illegalCount: "",
      // illegalCount2: "",
      first: false,
      dialogVisible: false,
      wechatUrl: "",
      wechatUrl2: "",
      nickname: "",
      openid: "",
      userid: "",
      showWechatDialog: false,
      tableLoading: false,
      findCampaignsLoading: false,
      scheduleDataLoading: false,
      score: "",
      realname: "",
      cycleList: "",
      tableData: [],
      findData: [],
      integrity: '',
      productNum: 0,
    };
  },
  created() {
    this.ScheduleBMC();
    this.$nextTick(() => {
      let bscrollDom = this.$refs.bscroll;
      this.aBScroll = new BScroll(bscrollDom,{
        startX:0,
        click:true,
        scrollX:true,
        scrollY:false,
      })
    });
    this.findCampaignsindex();
    this.Getlist();
    this.getUserById();
    this.ScheduleSeven();
    this.getCount();
    this.getCountByShop(1);
    // this.getCountBySecondAppeal()
    if (sessionStorage.getItem("key") == "false"||!sessionStorage.getItem("key")) {
      this.dealerIndex();
    }
    this.realname = JSON.parse(localStorage.getItem("userData")).realname
  },
  methods: {
    // 页面跳转
    jumpType() {
      if (JSON.parse(localStorage.getItem("userData")).logintype == 'DEALER') {
        this.$router.push('/DataInformation')
      } else {
        this.$router.push('/InformationMain')
      }
    },
    ScheduleBMC() {
      var timestamp =(new Date()).valueOf()
      this.scheduleDataLoading = true
      let type
      if (this.productType == '活动店铺') {
        type = 2
      } else {
        type = 1
      }
      let params={
        pageNo: 1,
        pageSize: 10000,
        type: type,
        start_time: this.$options.filters['fullTime'](timestamp).substring(0, 10)+ ' 23:59:59',
        end_time: this.$options.filters['fullTime'](timestamp).substring(0, 10) + ' 00:00:00',
      }
      fetch({
        url: "hcm/campgign/ScheduleBMC",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.scheduleData = []
          this.scheduleData = res.data.content;
          this.productNum = res.data.obj

          this.scheduleDataLoading = false
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    DetailsPage(e) {
      this.$router.push({
        path: '/AnnouncementDetails',query: {e}
      })
    },
    ToText(HTML) {
      if (HTML == null) {

      } else {
        var notice_content = HTML;
        return notice_content.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ').replace(/[ ]|[&nbsp;]/g,' ');
      }
    },
    findCampaignsindex() {
      this.findCampaignsLoading = true
      let params={
        pageNo: 1,
        pageSize: 10000,
      }
      fetch({
        url: "hcm/campgign/findCampaignsindex",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.findData = res.data;
          this.findCampaignsLoading = false
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    Getlist() {
      this.tableLoading = true
      let params={
        pageNo: 1,
        pageSize: 5,
      }
      fetch({
        url: "hcm/notice/Getlistindex",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.tableData = data.content;
          this.tableLoading = false
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 获取店铺档案完成度
    shopGetById() {
      fetchGet("/hcm/hcmShop/getById").then(res =>{
        if(res.status == "10000" && res.data){
          
          this.score = res.data.shopscore
          if (res.data.cycleList && res.data.cycleList.length > 1) {
            this.cycleList = res.data.cycleList[res.data.cycleList.length - 1]
          } else {
            if (res.data.cycleList && res.data.cycleList.length > 0) {
              this.cycleList = res.data.cycleList[0]
            }
          }
          this.integrity = res.data.integrity
          console.log(this.cycleList)
        }else{
          this.$message.info("接口报错");
        }
      })
    },
    // 获取经销商档案完成度
    findById(userid) {
      fetchGet("/hcm/dealer/findById").then(res =>{
        if(res.status == "10000" && res.data){
          
          this.score = res.data.score
          if (res.data.cycleList && res.data.cycleList.length > 1) {
            this.cycleList = res.data.cycleList[res.data.cycleList.length - 1]
          } else {
            if (res.data.cycleList && res.data.cycleList.length > 0) {
              this.cycleList = res.data.cycleList[0]
            }
          }
          this.integrity = res.data.integrity
          console.log(this.cycleList)
        }else{
          this.$message.info("接口报错");
        }
      })
    },
    onWechat() {
      this.$refs.childWxBinding.getbmcwx('c',this.userid,this.openid)
    },
    getUserById() {
      fetch({
        url: "hcm/userout/getUserById",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.nickname = res.data.nickname
          this.openid = res.data.openid
          this.userid = res.data.id

          if (JSON.parse(localStorage.getItem("userData")).logintype == "SHOP") {
            this.shopGetById()
          } else {
            this.findById(this.userid)
          }

        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    onBindWechat(userid) {
      this.$refs.childWxBinding.getbmcwx('c',userid)
    },
    iKnow() {
      //二维码弹窗
      this.showWechatDialog = false;
      sessionStorage.setItem("key", "true");
    },
    dealerIndex() {
      fetch({ url: "hcm/Index/dealerIndex", method: "get" }).then(res => {
        let { data } = res;
        if (res.status == "10000") {
          if (data.binding) {
            this.dialogVisible = false;
            sessionStorage.setItem("key", "true");//不显示
          } else {
            this.onBindWechat(data.userid);
          }
        }
      });
    },
    loadActive() {
      //热门活动产品滚动加载
      this.dateActive.pageNum += 5;
      if (this.first) this.ScheduleMBChome();
    },
    changeNav(index) {
      this.activeIndex = index;
      this.getData(index);
      this.getDataShop(index);
    },
    getData(index) {
      //热门活动
      let yearMonthDayTime = filter.yearMonthDayTime(
        this.activeList[index].my_date
      );
      this.dateActive.start_time = yearMonthDayTime + " " + "23:59:59";
      this.dateActive.end_time = yearMonthDayTime+ " " + "00:00:00";
      this.ScheduleMBChome();
    },
    getDataShop(index) {
      //活动店铺
      let yearMonthDayTime = filter.yearMonthDayTime(
        this.activeList[index].my_date
      );
      this.shopActive.start_time = yearMonthDayTime + " " + "23:59:59";
      this.shopActive.end_time = yearMonthDayTime+ " " + "00:00:00";
      this.ScheduleBMChomeShop();
    },
    ScheduleSeven() {
      //近期活动概览（获得七天条数）
      fetch({ url: "hcm/campgign/ScheduleSeven", method: "get" }).then(res => {
        if (res.status == "10000") {
          this.activeList = res.data.splice(0, 7);
          this.getData(0);
          this.getDataShop(0);
        }
      });
    },
    ScheduleMBChome() {
      //热门活动产品
      let data = this.dateActive;
      data.type = 1;
      fetch({
        url: "hcm/campgign/ScheduleBMChome",
        method: "get",
        params: data
      }).then(res => {
        if (res.status == "10000") {
          this.first = true;
          let result = res.data.data;
          for (let item of result) {
            let productList = [];
            let obj = {};
            for (let items of item.protuctc) {
              let obj = {};
              obj.nameVal = item[items.fieldvalue];
              obj.name = items.fieldname;
              productList.push(obj);
            }
            item.productList = productList;
          }
          this.hotActivity = result;
        }
      });
    },
    ScheduleBMChomeShop() {
      //活动店铺
      let data = this.shopActive;
      data.type = 2;
      fetch({
        url: "hcm/campgign/ScheduleBMChome",
        method: "get",
        params: data
      }).then(res => {
        if (res.status == "10000") {
          this.shopActivityList = res.data.data;
          console.log(res)
          console.log(this.shopActivityList)
        }
      });
    },
    getCountByShop(flowids) {
      //违规举报待响应 违规举报可二次申诉
      var timestamp = Date.parse(new Date());
      let data = {
        flowids,
        starttime: "2019-01-01",
        endtime: filter.yearMonthDayTime(timestamp)
      };
      fetch({
        url: "hcm/hcmReport/getCountByShop",
        method: "get",
        params: data
      }).then(res => {
        if (res.status == "10000") {
          if (res.data.length > 0) {
            if (flowids == 1) this.illegalCount = res.data[0].count; //违规举报待响应
          }
        }
      });
    },
    getCount() {
      //头部数量
      fetch({ url: "hcm/hcmChangeHistory/getCount", method: "get" }).then(
        res => {
          if (res.status == "10000") this.getCount = res.data;
        }
      );
    }
  }
};
</script>

<style lang="scss">
#indexDealers {
  #el-cardShadow {
    .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
      webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    .el-card, .el-message {
      border-radius: 0px;
      overflow: hidden;
    }
    .el-card {
      border: none;
    }
    .el-card__body {
      padding: 0px;
    }
  }
  .el-card, .el-message {
    border-radius: 12px;
  }
  .noData {
    width: calc(100% - 60px);
    text-align: center;
    background-color: white;
    padding: 20px;
    color: #999;
    height: 517px;
    margin-right: 20px;
    border-radius: 12px;
  }
  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.0) !important;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.0) !important;
  }
  .box-card {
    // height: 144px;
    margin-bottom: 20px;
  }
  .contentStyle {
    margin-bottom: 10px;
    padding-bottom: 32px;
    border-bottom: 1px solid #e8ebec;
    cursor: pointer;
  }
  .iconDiv {
    width: 5px;
    background-color: #333333;
    margin-right: 10px;
    height: 21px;
    margin-top: 4px;
  }
  .approvalHover {
    line-height: 50px;
    height: 50px;
  }
  .approvalHoverImage {
    margin-left: 15px;
    margin: auto;
    float: left;
  }
  .ellipsisStyle {
    line-height: 50px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .ellipsisStyle2 {
    margin-top: 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #999999;
  }
  .titleSpan {
    color: #999999;
    font-size: 14px;
    cursor: pointer;
    float: left;
    padding-left: 24px;
  }
  .titleSpan2 {
    margin-left: 20px;
    font-size: 24px;
    font-weight: bold;
  }
  .bscroll{
    width: 3000px;
    overflow: hidden;
    // margin-top: 40px;
    // margin-left: 40px;
  }
  .bscroll-container{
    width: 3430000px;
  }

  .leave {
    cursor: pointer;
  }
  .el-dialog__header {
    border-bottom: none;
  }
  .infinite-list {
    height: 200px;
    overflow-y: scroll;
    li {
      height: 100px;
    }
  }
  .seemore_tltle_have {
    font-size: 16px;
    color: #333;
    padding: 30px 0 14px 0;
    border-bottom: 1px solid #efefef;
    margin-bottom: 15px;
  }
  .el-collapse-item__header {
    position: relative;
    .seemore {
      position: absolute;
      right: 20px;
      top: 0;
      font-size: 14px;
      color: #666;
    }
    .seemore_tltle {
      font-size: 16px;
      color: #333;
    }
  }
  padding: 0 20px 0 20px;
  box-sizing: border-box;
  .header {
    .el-col-5 {
      background: #fff;
      height: 130px;
      border-radius: 6px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      position: relative;
      color: #666;
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      }
      img {
        margin-right: 25px;
        height: 55px;
      }
      .img_header1 {
        width: 49px;
      }
      .img_header2,
      .img_header3 {
        width: 55px;
      }
      .img_header4 {
        width: 51px;
      }
      .num {
        position: absolute;
        top: 0;
        right: 7px;
        color: #666;
        font-size: 30px;
      }
    }
  }
  .content {
    .elise_one {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 40%;
      margin-top: 10px;
    }
    margin-top: 23px;
    .header_title {
      height: 25px;
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #000018;
      &:before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 100%;
        background: #19233c;
        margin-right: 14px;
      }
    }
    .contentbg_load {
      height: 300px;
      overflow-y: scroll;
    }
    .contentbg {
      .activity_container {
        border-bottom: 1px solid #e8ebec;
        position: relative;
        .active_ing {
          position: absolute;
          right: 50px;
          top: 10px;
          font-size: 14px;
          color: #666666;
        }
      }
      .activity {
        margin-top: 15px;
        & > span {
          display: inline-block;
          margin-right: 30px;
          font-size: 14px;
          color: #666666;
        }
      }
      background: #fff;
      box-sizing: border-box;
      padding: 20px;
      border-radius: 12px;
      margin: 10px 0 25px 0;
    }
    .week_container {
      .one_header {
        height: 30px;
        line-height: 30px;
        .week {
          font-size: 14px;
          color: #666;
        }
        .today {
          font-size: 12px;
          width: 30px;
          height: 30px;
          background: #fde6b8;
          border-radius: 50%;
          display: inline-block;
          line-height: 30px;
          text-align: center;
          margin-left: 10px;
        }
        .num {
          font-size: 22px;
          color: #bda571;
          position: absolute;
          right: 7px;
          top: 10px;
        }
      }
      .two_header {
        font-size: 14px;
        margin-top: 15px;
      }
      display: flex;
      & > div {
        position: relative;
        flex: 1;
        border: 1px solid #e8ebec;
        height: 100px;
        box-sizing: border-box;
        text-align: left;
        padding: 11px 15px 15px;
        cursor: pointer;
      }
      .active {
        border-top: 4px solid #faad14;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.1s linear;
        .week {
          color: #333;
        }
      }
    }
  }
}
</style>
